import salesTypes from 'maps/sales-types';
import { EntityTypes } from 'context/entityContext';

export default function getSalesTypeOptions(
  isExternalUser: boolean,
  entityType: EntityTypes | 'version',
  hasSplitDownloads = false,
  forceNoEquivalents?: boolean,
  hasMedia?: boolean
): any {
  const getSalesTypes = (): any[] => {
    if (isExternalUser) {
      switch (entityType) {
        case 'track':
        case 'version': {
          if (hasSplitDownloads) {
            return [
              salesTypes.streaming,
              { ...salesTypes.track_downloads, label: 'Downloads' },
            ];
          }

          return [salesTypes.streaming, salesTypes.downloads];
        }
        case 'project':
        case 'artist': {
          if (hasSplitDownloads) {
            return [
              salesTypes.streaming,
              salesTypes.track_downloads,
              salesTypes.album_downloads,
              ...(hasMedia ? [] : [salesTypes.physical]),
            ];
          }

          return [
            salesTypes.streaming,
            salesTypes.downloads,
            ...(hasMedia ? [] : [salesTypes.physical]),
          ];
        }
        case 'album':
        case 'release': {
          if (hasSplitDownloads) {
            return [
              salesTypes.streaming,
              { ...salesTypes.album_downloads, label: 'Downloads' },
              ...(hasMedia ? [] : [salesTypes.physical]),
            ];
          }

          return [
            salesTypes.streaming,
            salesTypes.downloads,
            ...(hasMedia ? [] : [salesTypes.physical]),
          ];
        }
        case 'label':
        default: {
          return [];
        }
      }
    }

    switch (entityType) {
      case 'track':
      case 'version': {
        if (hasSplitDownloads) {
          return [
            salesTypes.equivalents,
            salesTypes.streaming,
            { ...salesTypes.track_downloads, label: 'Downloads' },
          ];
        }

        return [
          salesTypes.equivalents,
          salesTypes.streaming,
          salesTypes.downloads,
        ];
      }
      case 'project':
      case 'artist': {
        if (hasSplitDownloads) {
          return [
            salesTypes.equivalents,
            salesTypes.streaming,
            salesTypes.track_downloads,
            salesTypes.album_downloads,
            ...(hasMedia ? [] : [salesTypes.physical]),
          ];
        }

        return [
          salesTypes.equivalents,
          salesTypes.streaming,
          salesTypes.downloads,
          ...(hasMedia ? [] : [salesTypes.physical]),
        ];
      }
      case 'album':
      case 'release': {
        if (hasSplitDownloads) {
          return [
            salesTypes.equivalents,
            salesTypes.streaming,
            { ...salesTypes.album_downloads, label: 'Downloads' },
            ...(hasMedia ? [] : [salesTypes.physical]),
          ];
        }

        return [
          salesTypes.equivalents,
          salesTypes.streaming,
          salesTypes.downloads,
          ...(hasMedia ? [] : [salesTypes.physical]),
        ];
      }
      case 'label':
      default: {
        return [];
      }
    }
  };

  const salesTypeItems = getSalesTypes();

  if (forceNoEquivalents) {
    return salesTypeItems.filter((salesType) => {
      return salesType.value !== 'equivalents';
    });
  }

  return salesTypeItems;
}
